import { decodeToken } from '../services/JwtService.js';

export default {
	authenticated: state => state.token !== null,
	superuser(state) {
		const token = state.token;

		try {
			return decodeToken(token).data.superuser;
		} catch (e) {
			return false;
		}
	}
};
